import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '../Header/Header';
import Topics from '../Topics/Topics';
const Home = () => {
    const topics = useLoaderData();
    return (
        <div>
            <Header />
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 w-10/12 mx-auto py-14 px-4'>
            {
                    topics.data.map((topic) => <Topics key={topic.id} topic={ topic} />)
             }
            </div>
        </div>
    );
};

export default Home;     